"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessages = exports.usePagination = exports.DOTS = void 0;
var react_1 = require("react");
exports.DOTS = '...';
var getPages = function (lastPage, currentPage) {
    var pages = new Set();
    pages.add(1);
    pages.add(lastPage);
    pages.add(currentPage);
    if (currentPage === 1) {
        if (lastPage > 1) {
            pages.add(2);
        }
        if (lastPage > 2) {
            pages.add(3);
        }
    }
    else if (currentPage === lastPage) {
        if (lastPage > 1) {
            pages.add(lastPage - 1);
        }
        if (lastPage > 2) {
            pages.add(lastPage - 2);
        }
    }
    else {
        pages.add(currentPage - 1);
        pages.add(currentPage + 1);
    }
    return pages;
};
var usePagination = function (_a) {
    var totalCount = _a.totalCount, rowPerPage = _a.rowPerPage, currentPage = _a.currentPage;
    var paginationRange = (0, react_1.useMemo)(function () {
        var lastPage = Math.ceil(totalCount / rowPerPage);
        var pages = getPages(lastPage, currentPage);
        var pagesArray = Array.from(pages).sort(function (a, b) { return a - b; });
        if (pagesArray[1] === 3) {
            pagesArray.splice(1, 0, 2);
        }
        else if (pagesArray[1] !== 2 && pagesArray.length > 1) {
            pagesArray.splice(1, 0, exports.DOTS);
        }
        var pageBeforeLast = pagesArray[pagesArray.length - 2];
        if (pageBeforeLast === lastPage - 2) {
            pagesArray.splice(pagesArray.length - 1, 0, lastPage - 1);
        }
        else if (lastPage - pageBeforeLast > 2) {
            pagesArray.splice(pagesArray.length - 1, 0, exports.DOTS);
        }
        return pagesArray;
    }, [totalCount, rowPerPage, currentPage]);
    return paginationRange;
};
exports.usePagination = usePagination;
exports.defaultMessages = {
    next: 'Next',
    previous: 'Previous',
    pageCurrentOfLast: {
        id: 'pagination.pageCurrentOfLast',
        defaultMessage: 'Page {currentPage} of {lastPage}',
    },
    rowsPerPage: 'Rows per page',
};
